import { render, staticRenderFns } from "./chat-message-video.vue?vue&type=template&id=2d653cd9&scoped=true"
import script from "./chat-message-video.vue?vue&type=script&lang=js"
export * from "./chat-message-video.vue?vue&type=script&lang=js"
import style0 from "./chat-message-video.vue?vue&type=style&index=0&id=2d653cd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d653cd9",
  null
  
)

export default component.exports